module.exports = [{"type":"flavor","text":"Stepping off the plane, you recall a fragment of high school Japanese.","filters":[],"effects":[{"type":"flag","flag":"meditate-button","value":true},{"type":"flag","flag":"collections-unlocked","value":true},{"type":"learn","id":"hira-a"}]},{"type":"flavor","text":"You find a fabled Japanese vending machine.","filters":[],"effects":[{"type":"flag","flag":"vending-machine","value":true}]},{"type":"flavor","text":"A passerby gives you 100円.","filters":[],"effects":[{"type":"resource","resource":"yen","value":100}]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/collections/sample-event.json
// module id = 85
// module chunks = 0